import React, { Fragment } from 'react';

// React Bootstrap
import { Container, Card, Row, Col } from 'react-bootstrap';

// Packages
import PropTypes from 'prop-types';

// Components
import StatusBadge from '../../utils/StatusBadge';

// Utils
import { epochToLocalDate } from '../../../utils/dateConverter';
import { getWorkerInstanceStatusDesc, getWorkerStateDesc, getWorkerSpeedDesc } from '../../../utils/getStatusDesc';

const WorkerInstance = (props) => {
	const { workerInstance, showLink, workerId, resourceId } = props;

	return (
		<Card className='shadow mb-5 bg-body rounded card-border'>
			<Card.Body>
				<Card.Title className='text-center' as='h5'>{workerInstance.name}</Card.Title>
				<Card.Subtitle className='mb-2 text-center text-muted' as='p'><strong>Id:</strong> {workerInstance._id}</Card.Subtitle>
				<hr/>
				<Container className='p-0'>
					<Row>
						<Col className='text-center'><strong>Organization:</strong> {workerInstance.organization}</Col>
						<Col className='text-center'><strong>Runtime:</strong> {workerInstance.runtime}</Col>
					</Row>
					<hr/>
					<Row>
						<Col className='text-center'><strong>Mongo app name:</strong> {workerInstance.mongo_app_name}</Col>
						<Col className='text-center'><strong>Resource:</strong> {workerInstance.resource}</Col>
					</Row>
					<hr/>
					<Row>
						<Col className='text-center'>
							<strong>Start:</strong> {workerInstance.start !== 'None' ? epochToLocalDate(workerInstance.start) : 'None'}
						</Col>
						<Col className='text-center'>
							<strong>Stop:</strong> {workerInstance.stop !== 'None' ? epochToLocalDate(workerInstance.stop) : 'None'}
						</Col>
						<Col className='text-center'>
							<strong>End:</strong> {workerInstance.end !== 'None' ? epochToLocalDate(workerInstance.end) : 'None'}
						</Col>
					</Row>
					<hr/>
					<Row>
						<Col>
							<p className='text-center m-0 p-0'><strong>Last resource:</strong> {workerInstance.last_resource}</p>
							<p className='text-center m-0 p-0'><strong>Current resource:</strong> {workerInstance.current_resource}</p>
						</Col>
						<Col>
							<p className='text-center m-0 p-0'><strong>Last time:</strong> {epochToLocalDate(workerInstance.last_time * 1000)}</p>
							<p className='text-center m-0 p-0'><strong>Current time:</strong> {workerInstance.current_time}</p>
						</Col>
					</Row>
					<hr/>
					<Row>
						<Col>
							<p className='text-center m-0 p-0'><strong>Last status:</strong> <StatusBadge status={getWorkerInstanceStatusDesc(workerInstance.last_status)} /></p>
							<p className='text-center m-0 p-0'><strong>Force start:</strong> {workerInstance.force_start}</p>
						</Col>
						<Col>
							<p className='text-center m-0 p-0'><strong>State:</strong> <StatusBadge status={getWorkerStateDesc(workerInstance.state)} /></p>
							<p className='text-center m-0 p-0'><strong>Speed:</strong> {getWorkerSpeedDesc(workerInstance.speed)}</p>
						</Col>
					</Row>
					<hr/>
					<Row>
						<Col className='text-center'><strong>Worker events timeout:</strong> {workerInstance.worker_events_timeout}</Col>
						<Col className='text-center'><strong>Worker jobs timeout:</strong> {workerInstance.worker_jobs_timeout}</Col>
					</Row>

					{showLink &&
						<Fragment>
							<hr/>
							<Row className='text-end'>
								<Card.Link style={{ textDecoration: 'none' }} href={`/worker/${workerId}/resource/${resourceId}/instance/${workerInstance._id}`}>
									More info <i className='bi bi-chevron-right ms-2 me-1'></i>
								</Card.Link>
							</Row>
						</Fragment>
					}
				</Container>
			</Card.Body>
		</Card>
	);
}

WorkerInstance.propTypes = {
	workerInstance: PropTypes.object.isRequired,
	showLink: PropTypes.bool.isRequired,
	workerId: PropTypes.string,
	resourceId: PropTypes.string
}

export default WorkerInstance;
